<template>
    <GChart
      type="ColumnChart"
      :data="chartData"
      :options="options"
      style="width: 100%"
    />
  </template>
  
  <script>
  import { GChart } from 'vue-google-charts'
  
  export default {
    components: {
      GChart
    },
  
    props: {
      insights: {
        type: Object,
        default: () => ({})
      }
    },
  
    computed: {
      chartData() {
        return [
          ['Period', 'Payroll'],
          ['Last Month', Number(this.insights?.last_month || 0)],
          ['Current Month', Number(this.insights?.current_month || 0)]
        ]
      }
    },
  
    data() {
      return {
        options: {
          height: 300,
          legend: { position: 'none' },
          chartArea: { width: '80%', height: '70%' }
        }
      }
    }
  }
  </script>